
import { getLang, getTenantId, getTenantDir } from "@/plugins/env"
import { trackFooterClick } from "@/utils/track"
export default {
  name: "Bottom",
  // serverCacheKey: _ => {
  //   return `${getLang()}_PageFooter`
  // },
  data() {
    return {
      lang: this.$i18n.locale,
      dir: null,
      wellcomeList: [
        {
          name: "ourStory",
          url_zh_HK: this.$t("footer.ourStoryLink"),
          url_en_US: this.$t("footer.ourStoryLink")
        },
        {
          name: "corporateResponsibility",
          url_zh_HK: this.$t("footer.corporateResponsibilityLink"),
          url_en_US: this.$t("footer.corporateResponsibilityLink")
        },
        {
          name: "corporatePromotions",
          url_zh_HK: this.$t("footer.corporatePromotionsLink"),
          url_en_US: this.$t("footer.corporatePromotionsLink")
        },
        {
          name: "wellcomeWhatsAppTermsAndConditions",
          url_zh_HK: this.$t("footer.wellcomeWhatsAppTermsAndConditionsLink"),
          url_en_US: this.$t("footer.wellcomeWhatsAppTermsAndConditionsLink")
        },
        {
          name: "regardHreesixty",
          url_zh_HK: this.$t("footer.regardHreesixtyLink"),
          url_en_US: this.$t("footer.regardHreesixtyLink")
        }
      ],
      wellcomeListOther: [
        {
          name: "storeLocator",
          url_zh_HK: this.$t("footer.storeLocatorLink"),
          url_en_US: this.$t("footer.storeLocatorLink")
        },
        {
          name: "careers",
          url_zh_HK: this.$t("footer.careersLink"),
          url_en_US: this.$t("footer.careersLink")
        }
      ],
      tenantId: null
    }
  },
  computed: {},
  mounted() {
    this.tenantId = getTenantId()
  },
  methods: {
    goLink(item) {
      const name = item.name
      let url = ""
      switch (name) {
        case "ourStory":
          url = this.$t("footer.ourStoryLink")
          break
        case "regardHreesixty":
          url = this.$t("footer.regardHreesixtyLink")
          break
        default:
          break
      }
      window.open(url)
    },
    goDfiPage() {
      if (this.lang === "zh_HK") {
        window.open("https://www.dfiretailgroup.com/zh-HK")
      } else {
        window.open("https://www.dfiretailgroup.com/en")
      }
    },
    goAbout() {
      if (this.lang === "zh_HK") {
        window.open("https://www.yuurewards.com/zh-hant/faq?categoryKey=Wellcome.com.hk")
      } else {
        window.open("https://www.yuurewards.com/en/faq?categoryKey=Wellcome.com.hk")
      }
    },
    goTerms() {
      const termsAndConditionsLink = this.$t("footer.termsAndConditionsLink")
      window.open(termsAndConditionsLink)
    },
    goPolicy() {
      const privacyPolicyLink = this.$t("footer.privacyPolicyLink")
      window.open(privacyPolicyLink)
    },
    handleJump(type) {
      let name = ""
      switch (type) {
        case "email":
          name = "Contact us email"
          location.href = "mailto:" + this.$t("footer.email")
          break
        case "number":
          name = "Whatsapp"
          // window.open("https://wa.me/85221809733")
          break
        case "faq":
          name = "FAQs"
          this.goAbout()
          break
        case "terms":
          name = "Terms & Conditions"
          this.goTerms()
          break
        case "policy":
          name = "Privacy Policy"
          this.goPolicy()
          break
        case "dfi":
          name = "DFI Retail Group"
          this.goDfiPage()
          break
        case "emailBulkorder":
          location.href = "mailto:" + this.$t("footer.emailBulkorderLink")
          break
        default:
          break
      }
      this.trackFooterClick(name)
    },
    trackFooterClick,
    goItemLink(item) {
      const lang = this.$i18n.locale
      const url = item[`url_${lang}`]
      console.log(url, "urlurl")

      return url
    },
    handleDownload() {
      const link = document.createElement("a")
      link.href = this.$t("footer.foodPermitsLink")
      link.download = this.$t("footer.foodPermitsName")
      link.target = "_blank"
      link.click()
    },
    openDownladStore(url) {
      window.open(url)
    }
  }
}
